import LayoutHome from './LayoutHome'

export default LayoutHome
